import React from 'react';
import { CustomerGeneralTabContent } from './CustomerGeneralTabContent';
import { CustomerProjectsTabContent } from './CustomerProjectsTabContent';

export const CustomerTabContent = ({
    activeTab,
    customer,
    formatDate,
    isEditingProfile,
    profileForm,
    statusOptions,
    isSavingProfile,
    onProfileInputChange,
    onStartEditProfile,
    onCancelEditProfile,
    onSaveProfile,
}) => {
    if (activeTab === 'general') {
        return (
            <CustomerGeneralTabContent
                customer={customer}
                formatDate={formatDate}
                isEditingProfile={isEditingProfile}
                profileForm={profileForm}
                statusOptions={statusOptions}
                isSavingProfile={isSavingProfile}
                onProfileInputChange={onProfileInputChange}
                onStartEditProfile={onStartEditProfile}
                onCancelEditProfile={onCancelEditProfile}
                onSaveProfile={onSaveProfile}
            />
        );
    }

    if (activeTab === 'projects') {
        return <CustomerProjectsTabContent customerId={customer?._id} formatDate={formatDate} />;
    }

    return null;
};
